import { useEffect, useState } from "react";
import Table from '../../Table/Table';
import config from '../../../config';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom'
import { Eye } from 'lucide-react';

const SalesHistory = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const columns = ["ID", "Invoice No", "Date/time", "Type", "store", "Customer", "Customer Office", "Transaction Type", "Creadit Pay", "Due", "View"];

  useEffect(() => {
    fetchSalesHistory();
  }, []);
  const fetchSalesHistory = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/invoices`);
      if (!response.ok) {
        setError('Failed to fetch Sales Invoices');
        return;
      }
      const invoices = await response.json();
      const filteredInvoices = invoices
        .filter(invoice =>  invoice.store === "Colkan" || invoice.store === "TerraWalkers")
        .sort((a, b) => a.invoiceId - b.invoiceId);

      const transactionPromises = filteredInvoices.map(async (invoice) => {
        const transactionResponse = await fetch(`${config.BASE_URL}/transaction/invoice/${invoice.invoiceId}`);
        if (transactionResponse.ok) {
          return await transactionResponse.json();
        }
        return [];
      });

      const transactionsData = await Promise.all(transactionPromises);

      const formattedData = filteredInvoices.map((invoice, index) => {
        const invoiceDate = new Date(invoice.invoiceDate);

        const formattedInvoiceDate = `${invoiceDate.getFullYear()}-${String(invoiceDate.getMonth() + 1).padStart(2, '0')}-${String(invoiceDate.getDate()).padStart(2, '0')} ${String(invoiceDate.getHours()).padStart(2, '0')}:${String(invoiceDate.getMinutes()).padStart(2, '0')}`;

        const transactionPrice = transactionsData[index]?.reduce((total, transaction) => total + transaction.paid, 0);
        const transactiondue = transactionsData[index]?.reduce((total, transaction) => total + transaction.due, 0);
        const transactionTypes = transactionsData[index]?.map((transaction) => transaction.transactionType).join(', ') || "-";

        const currentYear = invoiceDate.getFullYear().toString().slice(-2);

        let invoiceName = ''
        if (invoice.store === 'Haman') {
          invoiceName = 'HN-INV-'
        } if (invoice.store === 'Colkan' || invoice.store === 'TerraWalkers') {
          invoiceName = 'INV-'
        }

        return [
          invoice.invoiceId,
          invoiceName + invoice.invoiceNo + '-' + currentYear,
          formattedInvoiceDate,
          invoice.status,
          invoice.store,
          invoice.customer?.cusName || '-',
          invoice.customer?.cusOffice || '-',
          transactionTypes || '-',
          transactionPrice.toFixed(2) || '-',
          transactiondue.toFixed(2) || '-',
          <div>
            {/* <Link to={`/selectDn/${invoice.invoiceNo}`}><button className="btn btn-primary">invoice</button></Link> */}
            <Link to={`/salesDetails/${invoice.store}/${invoice.invoiceNo}`}><button className="btn btn-warning"><Eye size={15} /></button></Link>
          </div>,
        ];
      });

      setData(formattedData);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  const title = 'Sales History';
  const invoice = 'Sales History.pdf';

  const handleDelete = async (rowIndex) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this invoice?");
    if (!confirmDelete) return;

    const adjustedIndex = (currentPage - 1) * itemsPerPage + rowIndex;
    const invoiceId = data[adjustedIndex][0];

    try {
      const response = await fetch(`${config.BASE_URL}/invoice/${invoiceId}`, { method: 'DELETE' });

      if (!response.ok) {
        const message = await response.text();
        throw new Error(`Failed to delete invoice: ${message}`);
      }

      // Remove the deleted item from data state
      const updatedData = data.filter(item => item[0] !== invoiceId);
      setData(updatedData);

      // Update pagination logic:
      // - If the current page becomes empty, move to the previous page
      if (updatedData.length % itemsPerPage === 0 && currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }

    } catch (err) {
      setError(err.message);
    }
  }

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (data.length > 0) {
      setCurrentPage(Math.ceil(data.length / itemsPerPage));
    }
  }, [data]);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const currentData = data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };


  return (
    <div>
      <div className="scrolling-container">
        <div className="new-sales-container">
          <h4>Sales History</h4>

          {isLoading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>Error: {error}</p>
          ) : (<p></p>)}
          <Table
            data={currentData}
            columns={columns}
            title={title}
            invoice={invoice}
            // onEdit={(rowIndex) => {
            //   const adjustedIndex = (currentPage - 1) * itemsPerPage + rowIndex;
            //   const invoiceId = data[adjustedIndex][0];
            //   const invoiceNo = data[adjustedIndex][1];
            //   const cusName = data[adjustedIndex][3];
            //   navigate(`/DraftSales/${invoiceId}/${invoiceType}`);
            // }}
            showButton={false}
            showEdit={false}
            onDelete={handleDelete}
          />

          {/* Pagination */}
          <div className="pagination justify-content-center">

            <button
              className="btn btn-primary"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              Previous
            </button>
            {/* last page */}
            {currentPage < totalPages - 1 && (
              <>
                <span
                  className={`mx-1 px-2 py-1 border ${totalPages === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePageChange(totalPages)}
                >
                  {totalPages}
                </span>
                {currentPage < totalPages - 1 && <span className="mx-1">...</span>}

              </>
            )}

            {/* Page Numbers */}
            {Array.from({ length: 5 }, (_, i) => currentPage - i)
              .filter(page => page > 1) // Ensure only valid pages are shown (except 1)
              .map((page, index) => (
                <span
                  key={index}
                  className={`mx-1 px-2 py-1 border ${page === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </span>
              ))
            }

            {totalPages > 2 && <span className="mx-1">...</span>}
            {totalPages > 1 && (
              <span className={`mx-1 px-2 py-1 border ${currentPage === 1 ? 'border-primary  fw-bold' : 'border-transparent'}`} style={{ cursor: "pointer" }} onClick={() => handlePageChange(1)}
              >
                1
              </span>
            )}
            <button className="btn btn-primary" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage <= 1} >Next</button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SalesHistory;
